export default __webpack_public_path__ + "static/media/Licenses_IMG-QA-05.074a13d8.png";